import styled from "styled-components";

const FillView = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
`;

export default FillView;
